import { QueryClient, QueryClientProvider, QueryCache, MutationCache } from '@tanstack/react-query'
import * as Sentry from '@sentry/react'
import { RootPage } from './pages/RootPage'
import { pb } from './pocketbase/Pocketbase'
import { useAuthStore } from './data/useAuthStore'

const handleAuthError = (error: any) => {
  const status = error?.status

  if (status === 401 || status === 403) {
    console.warn("Auth error, clearing session")

    // Optional: breadcrumb instead of exception
    Sentry.addBreadcrumb({
      category: "auth",
      message: "Unauthorized / forbidden response",
      level: "info",
    })

    pb.authStore.clear()
    useAuthStore.getState().reset()
    window.location.href = "/"
    return
  }

  // Only unexpected errors reach here
  console.error("Global Query/Mutation Error:", error)
  Sentry.captureException(error)
}

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: handleAuthError,
  }),
  mutationCache: new MutationCache({
    onError: handleAuthError,
  }),
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
    },
  },
})

export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <RootPage />
    </QueryClientProvider>
  )
}
